var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MatchReadPopup',{attrs:{"isModal":_vm.modalPopup.matchNapPopup}}),_c('AnswerNapPopup',{attrs:{"isModal":_vm.modalPopup.answerNapPopup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }